import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';
import { RouterLink } from '@angular/router';
import { MetaMenuLinkItemViewModel } from '@models/api.models';
import { BadgeComponent } from '@shared/badge/badge.component';
import { ClubService } from '@features/club/service/club.service';
import { AsyncPipe } from '@angular/common';
import { MoreThanPipe } from '@features/navigation/pipes/more-than.pipe';

import { fadeTransition } from '@shared/animations/animations';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
    selector: 'app-club-member-link',
    imports: [TranslateSafePipe, RouterLink, BadgeComponent, AsyncPipe, MoreThanPipe],
    templateUrl: './club-member-link.component.html',
    styleUrl: './club-member-link.component.scss',
    animations: [fadeTransition],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClubMemberLinkComponent {
    private clubService = inject(ClubService);
    public clubPoints$ = this.clubService.getClubPoints().pipe(
        catchError(_ => of(null)),
        map(data => data ?? { points: 0 })
    );

    @Input() item: MetaMenuLinkItemViewModel;
}
